import { EventResponse } from '@app/services'
import dayjs from 'dayjs'

export const createGoogleCalendarUrl = (event: EventResponse) => {
  const startTime = dayjs.utc(event.start_time_utc).local()
  // Default to 1 hour if end_time not specified
  const endTime = event.end_time_utc
    ? dayjs.utc(event.end_time_utc).local()
    : startTime.add(1, 'hour')

  const details =
    event.event_description ||
    'Enjoy four 1:1 breakout sessions with auto-matching, featuring discussion questions and new vocabulary for engaging conversations. This is a 1 hour session, and you can join anytime, but preferably not in the last 5 minutes!'

  const url = new URL('https://calendar.google.com/calendar/render')
  url.searchParams.append('action', 'TEMPLATE')
  url.searchParams.append('text', event.event_title || "SpeakDuo Let's Go!")
  url.searchParams.append('location', 'https://speakduo.com/live')
  url.searchParams.append(
    'dates',
    `${startTime.format('YYYYMMDD[T]HHmmss')}/${endTime.format('YYYYMMDD[T]HHmmss')}`,
  )
  url.searchParams.append('details', details)

  return url.toString()
}
